import { render, staticRenderFns } from "./DropdownWrap.vue?vue&type=template&id=16fd65f0"
import script from "./DropdownWrap.vue?vue&type=script&lang=js"
export * from "./DropdownWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports